import { stickyHeader } from "./sticky-header";
import { stickyBackToTop } from "./scroll-links";

(function ($) {
  "use strict";

  $(document).ready(function () {
    scrollingInit();
  });
})(jQuery);

function scrollingInit() {
  var scroll, scroller;

  scroll =
    window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    window.oRequestAnimationFrame ||
    // IE Fallback, you can even fallback to onscroll
    function (callback) {
      window.setTimeout(callback, 1000 / 60);
    };

  var forceScroller = false;
  var lastPosition = -1;
  var lastLongFromIndexHeight = -1;

  scroller = function () {
    var scrollValues = scrollVariables();

    if (
      lastPosition == scrollValues.scrollOffset &&
      lastLongFromIndexHeight == scrollValues.longFormIndexHeight &&
      !forceScroller
    ) {
      scroll(scroller);
      return false;
    }

    var semiStaticScrollValues = semiStaticScrollVariables();

    stickyHeader(
      scrollValues.scrollOffset,
      semiStaticScrollValues.pageHeadHeight
    );

    stickyBackToTop(
      scrollValues.scrollOffset,
      semiStaticScrollValues.screenHeight,
      semiStaticScrollValues.footerOffset,
    );

    lastPosition = scrollValues.scrollOffset;
    lastLongFromIndexHeight = scrollValues.longFormIndexHeight;
    forceScroller = false;
    scroll(scroller);
  };

  scroller();

  setTimeout(function () {
    var scrollValues = scrollVariables();
    var semiStaticScrollValues = semiStaticScrollVariables();

    stickyBackToTop(
      scrollValues.scrollOffset,
      semiStaticScrollValues.screenHeight,
      semiStaticScrollValues.footerOffset
    );

  }, 210);

  $(window).on("resize.scroller", function () {
    forceScroller = true;
  });
}


function scrollVariables() {
  const scrollTop = window.scrollY || window.pageYOffset;

  return {
    scrollOffset: scrollTop,
    longFormIndexHeight:
      $("#lf-doc-nav").length > 0 ? $("#lf-doc-nav").outerHeight() : -1,
  };
}

function semiStaticScrollVariables() {
  return {
    screenHeight: window.innerHeight,
    footerOffset: $("#page-foot").length ? $("#page-foot").position().top : 0,
    pageHeadHeight: $("#page-head").length ? $("#page-head").outerHeight() : 0,
    longFormDocContentOffset:
      $(".lf-nav-wrapper").length > 0 ? $(".lf-doc-lower").position().top : -1,
    longFormDocHeaderHeight:
      $("#lf-doc-nav").length > 0 ? $("#lf-doc-nav > h2").outerHeight() : -1,
  };
}
